import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";

@Component({
  selector: "app-add-customer-bank",
  templateUrl: "./add-customer-bank.component.html",
  styleUrls: ["./add-customer-bank.component.css"],
})
export class AddCustomerBankComponent implements OnInit {
  title = "Add Bank";
  customerBank: any = {
    name: "",
  };
  bankId: number;
  isEditState = false;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.bankId = +this.route.snapshot.params["id"];
    if (this.bankId > 0) {
      this.isEditState = true;
      this.title = "Edit Bank";
      this.getBank(this.bankId);
    }
  }

  getBank(id: number) {
    this.slimLoadingBarService.start();
    this.userService.getCustomerBankById(id).subscribe(
      (data: any) => {
        this.customerBank = {
          id: data.id,
          name: data.name,
        };
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  addBank() {
    this.slimLoadingBarService.start();
    const payload = {
      name: this.customerBank.name,
    };
    let serUrl;
    if (this.customerBank && this.customerBank.id) {
      serUrl = this.userService.updateCustomerBank(this.customerBank.id, payload);
    } else {
      serUrl = this.userService.addCustomerBank(payload);
    }
    serUrl.subscribe(
      () => {
        swal("Added Bank successfully", "", "success");
        this.customerBank = {
          name: "",
        };
        this.router.navigateByUrl("/pages/settings/customer-banks");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/add-customer-bank/add-customer-bank.component.ts